import { C as Component } from "./component-DqhvLgtR.js";
import { d as defineCustomElement, t as throttle } from "./utilities-DuXQiAqj.js";
class BackToTop extends Component {
  requiredRefs = ["button"];
  #scrollThreshold = 300;
  #isVisible = false;
  connectedCallback() {
    super.connectedCallback();
    const handleScroll = throttle(() => this.#checkScrollPosition(), 100);
    window.addEventListener("scroll", handleScroll, { passive: true, signal: this.signal });
    this.#checkScrollPosition();
  }
  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
  #checkScrollPosition() {
    const shouldShow = window.scrollY > this.#scrollThreshold;
    if (shouldShow && !this.#isVisible) {
      this.#show();
    } else if (!shouldShow && this.#isVisible) {
      this.#hide();
    }
  }
  #show() {
    this.#isVisible = true;
    this.refs.button.classList.add("is-visible");
    this.refs.button.setAttribute("aria-hidden", "false");
  }
  #hide() {
    this.#isVisible = false;
    this.refs.button.classList.remove("is-visible");
    this.refs.button.setAttribute("aria-hidden", "true");
  }
}
defineCustomElement("back-to-top", BackToTop);
